import { createIcon } from '../createIcon';

export const KeyIconConfig = {
  name: 'KeyIcon',
  height: 1024,
  width: 1024,
  svgPath: 'M965.486 804.571c0 0-58.514 80.457-109.714 102.4-160.914 87.771-358.4 29.257-446.171-124.343-51.2-87.771-58.514-190.171-21.943-277.943l-387.657-380.343v-197.486h182.857v109.714h109.714v109.714h146.286l138.971 168.229c168.229-65.829 358.4 21.943 424.229 190.171 36.571 102.4 21.943 212.114-36.571 299.886zM885.029 731.428v0c0-58.514-43.886-102.4-102.4-102.4v0c-58.514 0-102.4 43.886-102.4 102.4s43.886 102.4 102.4 102.4c58.514 7.314 102.4-43.886 102.4-102.4v0z',
  yOffset: 64,
  xOffset: 0,
  transform: 'rotate(180 0 512) scale(-1 1)'
};

export const KeyIcon = createIcon(KeyIconConfig);

export default KeyIcon;